var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeftDoubleFill = function SvgArrowLeftDoubleFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m6.53 12 5.173 5.172 1.178-1.178L8.887 12l3.994-3.994-1.178-1.179zm4.708 0 5.173 5.172 1.178-1.178L13.595 12l3.994-3.994-1.178-1.179z"
  })));
};
export default SvgArrowLeftDoubleFill;